export default {
  titles: {
    pickup: 'Afhentning',
    delivery: 'Levering',
  },
  buttons: {
    confirm: 'Bekræft',
  },
};
